<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="createContenidoNodo"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionAssetContentsModalCreateSubContent.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <AtomInputPrimary
          v-model="nodo.nodo.nombre"
          :inputError="$v.nodo.nodo.nombre.$error"
          :label="$t('mEditionAssetContentsModalCreateSubContent.inputs.nombre.label')"
          :messageError="messageErrorNombre"
          name="nombre"
          type="text"
          @blur="$v.nodo.nodo.nombre.$touch()"
        />
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionAssetContentsModalCreateSubContent.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeEditionAssetContentsModalCreateSubContent',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionAssetContentsModalCreateSubContent.buttonPrimary'),
        class: 'a-button-assets-primary',
        sending: false,
        type: 'submit'
      },

      nodo: {
        academia: 0,
        proyecto: 0,
        nodo: {
          nombre: '',
          titulo: '',
          padre: '',
          descripcion: ''
        }
      }
    }
  },

  validations: {
    nodo: {
      nodo: {
        nombre: {
          maxLength: maxLength(255),
          minLength: minLength(5),
          required
        }
      }
    }
  },

  computed: {
    messageErrorNombre () {
      return this.$validation.getValidationMessage('mEditionAssetContentsModalCreateSubContent', this.$v.nodo.nodo.nombre, 'nodo', 'nombre')
    }
  },

  watch: {
    'nodo.nodo.nombre' () {
      this.nodo.nodo.titulo = this.nodo.nodo.nombre
    }
  },

  created () {
    this.nodo.academia = this.$store.getters.getAcademyData.id
    this.nodo.proyecto = this.$route.params.id
    this.nodo.nodo.padre = this.$modal.element.padre
  },

  methods: {
    createContenidoNodo () {
      this.$v.$touch()
      if (!this.$v.$invalid && !this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.create('contenido', 'createContenidoNodo', this.nodo, [this.$modal.element.version.id])
          .then(response => {
            let newNode = Object.assign({}, response.data)
            newNode.children = []
            this.$store.commit('setAssetSelectedNode', newNode)
            this.$modal.updateData('readElement')
            this.$modal.closeModal()
            this.$alerts.pushAlert('mEditionAssetContentsModalCreateSubContent', 'createContenidoNodo', 'success')
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionAssetContentsModalCreateSubContent', 'createContenidoNodo', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
